export interface IQueriesHubProps {
}